import React from 'react';
import PermButton from '../../core/utils/PermButton';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PlusCircle, ChevronUp, Table, Grid } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { actions as mainActions, showModal } from 'Core/redux/main/slice';
import { actions as carrierActions } from './store/slice';
import { selectTileView } from './store/selectors';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { setToogleHeader } = mainActions;
const { setTileView } = carrierActions;
const { CARRIERS_ADD_EDIT } = MODAL_TYPES;

const CarrierTopHead = () => {
  const dispatch = useDispatch();
  const headerVisible = useSelector(isHeaderVisible);
  const tileView = useSelector(selectTileView);

  const renderCollapseTooltip = props => <Tooltip {...props}>Collapse</Tooltip>;
  const renderTileViewTooltip = props => (
    <Tooltip {...props}>{tileView ? 'Table View' : 'Tile View'}</Tooltip>
  );

  return (
    <>
      <ul className="table-top-head">
        <li>
          <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
            <Link
              to="#"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              id="collapse-header"
              className={headerVisible ? 'active' : ''}
              onClick={() => {
                dispatch(setToogleHeader(!headerVisible));
              }}
            >
              <ChevronUp />
            </Link>
          </OverlayTrigger>
        </li>
        <li>
          <OverlayTrigger placement="top" overlay={renderTileViewTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={() => {
                dispatch(setTileView(!tileView));
              }}
            >
              {tileView ? <Table /> : <Grid />}
            </Link>
          </OverlayTrigger>
        </li>
      </ul>

      <div className="d-flex purchase-pg-btn">
        <div className="page-btn">
          <PermButton perm="MASTERS.CARRIER.CREATE">
            <Link
              to="#"
              className="btn btn-added"
              onClick={() => {
                dispatch(showModal(CARRIERS_ADD_EDIT));
              }}
            >
              <PlusCircle className="me-2" />
              Add New Carrier
            </Link>
          </PermButton>
        </div>
      </div>
    </>
  );
};

export default CarrierTopHead;

